<template>
  <li class="episode" :class="{'episode--dark-mode': darkMode}" :data-test="`tab-playlist--entry${episode.active ? '--active' : ''}`">
    <div class="cursor-pointer" @click="select(index, true)" aria-hidden="true" data-test="tab-playlist--entry--interaction">
      <span class="inline-block" data-test="tab-playlist--entry--title"> {{ episode.title }} </span>
    </div>
  </li>
</template>

<script>
import { mapState } from 'redux-vuex';

import { requestPlay, requestPause } from '@/store/actions/play';
import { toHumanTime } from '@/utils/time';
import select from '@/store/selectors';
import store from '@/store';
import { selectEpisode } from '@/store/actions/playlist';

export default {
  components: {
  },

  props: {
    index: {
      type: Number,
      default: null,
    },
    episode: {
      type: Object,
      default: () => ({}),
    },
  },

  data: mapState({
    color: select.theme.brandLightest,
    playing: select.driver.playing,
    darkMode: select.customOptions.darkMode,
  }),

  computed: {
    a11y() {
      const remaining = this.chapter.active
        ? this.chapter.end - this.playtime
        : this.chapter.end - this.chapter.start;

      return {
        ...this.chapter,
        remaining: toHumanTime(remaining > 0 ? remaining : 0),
        duration: toHumanTime(this.chapter.end - this.chapter.start),
      };
    },
  },

  methods: {
    play() {
      store.dispatch(this.playing ? requestPause() : requestPlay());
    },

    /**
     * Triggers the switch to another episode.
     *
     * @param {number} index episode which shall be selected
     * @param {boolean} play whether to automatically start playing
     */
    select(index, play) {
      store.dispatch(selectEpisode({ index, play }));
    },
  },
};
</script>

<style scoped lang="scss">
  @import '~@/assets/scss/media.scss';

  .episode {
    color: #000000;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    overflow: hidden;

    @include only-desktop() {
      font-size: 14px;
    }

    &--active, &:hover {
      font-weight: bold;
    }

    &--dark-mode {
      color: #FFFFFF;
    }
  }
</style>
